export default __webpack_public_path__ + "static/media/社区聚集地.4f7cf16e.jpg";